import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordList2Icon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;

  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <path
        d="M1.065 2.332h15.87M1.065 9.118h15.87M1.065 15.903h15.87"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth='2'
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BordList2Icon;
